module.exports = __webpack_public_path__ + "static/media/onboarding_flo.7e30e834.png";